import { Box, Popover } from "@mui/material"

function PopoverSeekerArrow({ isOpen, ...props }) {
    return (
        <Box
            component="span"
            {...props}
            sx={{
                display: isOpen ? "block" : "none",
                position: "absolute",
                zIndex: 1,
                width: 12,
                height: 12,
                content: '""',
                transform: "rotate(-135deg)",
                backgroundColor: "background.paper",
                borderRadius: "0 0 3px 0",
                top: -6,
                right: 20,
                ...props?.sx,
            }}
        />
    )
}

export default function PopoverSeeker({ anchorEl, onClose, children, arrowProps = {}, ...props }) {
    const isOpen = Boolean(anchorEl)
    return (
        <Popover
            open={isOpen}
            anchorEl={anchorEl}
            onClose={onClose}
            {...props}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
                ...props?.anchorOrigin,
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
                ...props?.transformOrigin,
            }}
            slotProps={{
                ...props?.slotProps,
                paper: {
                    ...props?.slotProps?.paper,
                    sx: {
                        p: 1,
                        ml: 0.75,
                        width: "auto",
                        overflow: "inherit",
                        "& .MuiMenuItem-root": {
                            p: 1,
                            typography: "body1",
                            borderRadius: 0.75,
                        },
                        ...props?.slotProps?.paper?.sx,
                    },
                },
            }}
        >
            <PopoverSeekerArrow isOpen={isOpen} {...arrowProps} />
            {children}
        </Popover>
    )
}
